import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ModalModule } from 'ngx-bootstrap';
import { CollapseModule } from 'ngx-bootstrap/collapse';


import { AppRoutingModule } from './app.routing';

import { AppComponent } from './app.component';

import { HomeModule } from './home/home.module';
import { ActualiteModule } from './actualite/actualite.module';
import { NouveauteModule } from './nouveaute/nouveaute.module';
import { ArticleModule } from './article/article.module';
import { CmsModule } from './cms/cms.module';
import { KneServicesModule } from './kne-services/kne-services.module';
import { UserModule } from './user/user.module';

import {
  ApiService,
  UserService,
  ContextService,
  JwtService,
  FooterComponent,
  HeaderComponent,
  ListComponent,
  LoginComponent,
  EspaceComponent,
  SearchComponent,
  PanierComponent,
  SharedModule,
} from './shared';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    ListComponent,
    LoginComponent,
    EspaceComponent,
    PanierComponent,
    SearchComponent,
    // TestUploadComponent,
  ],
  imports: [
    BrowserModule,
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
    HomeModule,
    CmsModule,
    ActualiteModule,
    NouveauteModule,
    ArticleModule,
    KneServicesModule,
    UserModule,
    AppRoutingModule,
    SharedModule,
  ],
  providers: [
    ApiService,
    UserService,
    ContextService,
    JwtService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts